// extracted by mini-css-extract-plugin
module.exports = {"main-menu":"Menu_main-menu__yArdg","has-open":"Menu_has-open__pKirp"};